'use client';

import React from 'react';
import { X } from 'react-feather';
import styled from 'styled-components';

// Styled components
export const CloseIcon = styled(X) <{ onClick: () => void }>`
    cursor: pointer;
`;


export const GradientButton = styled.button`
    font-size: 18px;
    line-height: 27px;
    font-family: "Sora", "Quicksand", sans-serif; 
    text-decoration: none;
    backdrop-filter: blur(40px);
    padding: 0.5rem 1.3rem;
    background: linear-gradient(270deg, rgba(31, 31, 50, 0.4) 0%, rgba(31, 32, 49, 0.4) 49.48%, rgba(120, 88, 56, 0.4) 100%);
    border-radius: 50px;
    border: ${({ disabled }: { disabled?: boolean }) => `2px solid #B96A05`};
    opacity: ${({ disabled }: { disabled?: boolean }) => (disabled ? '0.5' : '1')};
    cursor: ${({ disabled }: { disabled?: boolean }) => (disabled ? 'default' : 'pointer')};
    color: #FFFFFF;
    font-weight: 500;
    margin: 0 1rem;
    :hover {
        color: #B96A05;
    }
    :focus {
        outline: none;
    }
    :active {
        text-decoration: none;
    }
    :disabled {
        cursor: not-allowed;
        color: white;
        opacity: 0.5;
    }
    @media (max-width: 992px) {
        padding: 0.3rem 0.9rem;
        position: relative;
    }
`;

export const PrimaryButton = styled.button`
    background: linear-gradient(90deg, #B96A05 7.81%, #F28903 100%);
    border-radius: 22px;
    color: white;
    font-weight: 700;
    font-size: 20px;
    line-height: 30px;
    letter-spacing: .1rem;
    padding: .8rem 2.5rem;
    transition: all .1s;
    &:hover {
        color: #72450b;
    }
    :disabled {
        background: linear-gradient(90deg,#6a4618 7.81%,#935b14 100%);
        color: #b9b9b9;
        cursor: not-allowed;
    }
`;

export const NormalButton = styled(GradientButton as any)`
    background: #F38F2E;
    border-width: 1px;
    font-size: 14px;
`;

export const ModalToggleButton = styled.button`
    font-weight: 600;
    font-size: 16px;
    line-height: 19.2px;
    color: white;
    font-style: normal;
    text-decoration-line: underline;
    text-shadow: 2px 3px 4px rgba(0, 0, 0, 0.7);
    :hover {
        cursor: pointer;
        color: #F8A93E;
    }
    :disabled {
        cursor: not-allowed;
        color: white;
        opacity: 0.5;
    }
`;